import React from "react"

export default function Dashboard() {
    return <div><h3>Dashboard</h3></div>
}